export const OPERATIONS = {
  TICKET: "ticket",
  UNAVAILABILITY: "unavailability",
} as const;
